var map = {
	"./add.png": 25716,
	"./app-phone-1x.png": 70600,
	"./app-phone-2x.png": 36740,
	"./app-phone-3x.png": 44128,
	"./app-phone.jpg": 76920,
	"./appstore-badge.jpg": 77644,
	"./appstore-badge.png": 5268,
	"./arrow.png": 48884,
	"./artigianalita-top-1440.jpg": 580,
	"./assistenza.jpg": 86948,
	"./book.png": 42580,
	"./cart-white.png": 6487,
	"./cashback-di-stato.svg": 84916,
	"./cashback-mail.jpg": 81828,
	"./checkout.png": 80248,
	"./flash.png": 44192,
	"./google-play-badge.jpg": 56852,
	"./google-play-badge.png": 80332,
	"./invitation-preview.jpg": 46476,
	"./logo-mamaclean-plus.png": 5692,
	"./logo-satispay-wide.png": 60560,
	"./logo-satispay.png": 71856,
	"./logo-white.png": 98320,
	"./logo.png": 3884,
	"./mailbox.png": 3924,
	"./pattern-light.jpg": 13384,
	"./pattern.png": 67800,
	"./prenota.jpg": 76724,
	"./referral-page-facebook.jpg": 20164,
	"./referral-page-twitter.jpg": 32864,
	"./referral.jpg": 73856,
	"./referral2_3_mail.png": 62941,
	"images/add.png": 25716,
	"images/app-phone-1x.png": 70600,
	"images/app-phone-2x.png": 36740,
	"images/app-phone-3x.png": 44128,
	"images/app-phone.jpg": 76920,
	"images/appstore-badge.jpg": 77644,
	"images/appstore-badge.png": 5268,
	"images/arrow.png": 48884,
	"images/artigianalita-top-1440.jpg": 580,
	"images/assistenza.jpg": 86948,
	"images/book.png": 42580,
	"images/cart-white.png": 6487,
	"images/cashback-di-stato.svg": 84916,
	"images/cashback-mail.jpg": 81828,
	"images/checkout.png": 80248,
	"images/flash.png": 44192,
	"images/google-play-badge.jpg": 56852,
	"images/google-play-badge.png": 80332,
	"images/invitation-preview.jpg": 46476,
	"images/logo-mamaclean-plus.png": 5692,
	"images/logo-satispay-wide.png": 60560,
	"images/logo-satispay.png": 71856,
	"images/logo-white.png": 98320,
	"images/logo.png": 3884,
	"images/mailbox.png": 3924,
	"images/pattern-light.jpg": 13384,
	"images/pattern.png": 67800,
	"images/prenota.jpg": 76724,
	"images/referral-page-facebook.jpg": 20164,
	"images/referral-page-twitter.jpg": 32864,
	"images/referral.jpg": 73856,
	"images/referral2_3_mail.png": 62941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91320;